var map = {
	"./1/cover.jpg": "Mll0",
	"./10/cover.jpg": "gbi1",
	"./11/cover.jpg": "clg1",
	"./2/cover.jpg": "jm47",
	"./3/cover.jpg": "cDuX",
	"./4/cover.jpg": "gJFe",
	"./5/cover.jpg": "2bhG",
	"./6/cover.jpg": "rP11",
	"./7/cover.jpg": "Raai",
	"./8/cover.jpg": "girg",
	"./9/cover.jpg": "ts4u"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/u4L";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2 ^\.\/.*\/cover\.jpg$
// module id = /u4L
// module chunks = 27